module.exports = __webpack_public_path__ + "img/A_diamonds.efa71b47.png";